const removeStringSpaces = (str: string): string => str.replace(/\s/g, "");

export default removeStringSpaces;
